<template>
    <v-row id="eligibility-form">
        <v-container class="container-width">
            <v-form ref="form" v-model="formValid" :key="formKey">
                <v-row v-if="normalizedOptions.title.show">
                    <v-col cols="12">
                        <h2
                            :class="normalizedOptions.title.classes"
                            :style="normalizedOptions.title.style"
                        >
                            {{ normalizedOptions.title.text }}
                        </h2>
                    </v-col>
                </v-row>
                <v-row v-if="normalizedOptions.intro.show">
                    <v-col cols="12" lg="6" xl="6">
                        <div
                            :class="normalizedOptions.intro.classes"
                            :style="normalizedOptions.intro.style"
                            v-html="normalizedOptions.intro.textHtml"
                        ></div>

                        <h2
                            v-if="
                                normalizedOptions.sections.personalInformation
                                    .title.show
                            "
                            :class="
                                normalizedOptions.sections.personalInformation
                                    .title.classes
                            "
                            :style="
                                normalizedOptions.sections.personalInformation
                                    .title.style
                            "
                        >
                            {{
                                normalizedOptions.sections.personalInformation
                                    .title.text
                            }}
                        </h2>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.title.show"
                        >
                            <label
                                for="titleField"
                                v-if="
                                    !normalizedOptions.fields.title.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.title.label }}
                            </label>
                            <v-select
                                id="titleField"
                                v-model="formFields.title"
                                :items="titleChoices"
                                :label="
                                    normalizedOptions.fields.title.inlineLabels
                                        ? normalizedOptions.fields.title.label
                                        : ''
                                "
                                :required="
                                    normalizedOptions.fields.title.required
                                "
                                outlined
                                clearable
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.title.required
                                        ? rules.title
                                        : []
                                "
                                :error="getError('title')"
                                :error-messages="getErrorMessages('title')"
                                @input="removeErrorMessage('title')"
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.firstName.show"
                        >
                            <label
                                for="firstNameField"
                                v-if="
                                    !normalizedOptions.fields.firstName
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.firstName.label }}
                            </label>
                            <v-text-field
                                id="firstNameField"
                                v-model="formFields.firstName"
                                :label="
                                    normalizedOptions.fields.firstName
                                        .inlineLabels
                                        ? normalizedOptions.fields.firstName
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.firstName.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.firstName.required
                                        ? rules.firstName
                                        : []
                                "
                                :error="getError('firstName')"
                                :error-messages="getErrorMessages('firstName')"
                                @input="removeErrorMessage('firstName')"
                            ></v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.lastName.show"
                        >
                            <label
                                for="lastNameField"
                                v-if="
                                    !normalizedOptions.fields.lastName
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.lastName.label }}
                            </label>
                            <v-text-field
                                id="lastNameField"
                                v-model="formFields.lastName"
                                :label="
                                    normalizedOptions.fields.lastName
                                        .inlineLabels
                                        ? normalizedOptions.fields.lastName
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.lastName.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.lastName.required
                                        ? rules.lastName
                                        : []
                                "
                                :error="getError('lastName')"
                                :error-messages="getErrorMessages('lastName')"
                                @input="removeErrorMessage('lastName')"
                            ></v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.dateOfBirth.show"
                        >
                            <v-menu
                                ref="menu"
                                v-model="showDatePicker"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <label
                                        for="dateOfBirthField"
                                        v-if="
                                            !normalizedOptions.fields
                                                .dateOfBirth.inlineLabels
                                        "
                                        class="mb-4 font-weight-bold"
                                    >
                                        {{
                                            normalizedOptions.fields.dateOfBirth
                                                .label
                                        }}
                                    </label>
                                    <v-text-field
                                        v-model="dateOfBirthFormatted"
                                        :label="
                                            normalizedOptions.fields.dateOfBirth
                                                .inlineLabels
                                                ? normalizedOptions.fields
                                                      .dateOfBirth.label
                                                : ''
                                        "
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        outlined
                                        clearable
                                        :required="
                                            normalizedOptions.fields.dateOfBirth
                                                .required
                                        "
                                        hide-details="auto"
                                        class="rounded-0 mb-4"
                                        background-color="white"
                                        :rules="
                                            normalizedOptions.fields.dateOfBirth
                                                .required
                                                ? rules.dateOfBirth
                                                : []
                                        "
                                        :error="getError('dateOfBirth')"
                                        :error-messages="
                                            getErrorMessages('dateOfBirth')
                                        "
                                        @input="
                                            removeErrorMessage('dateOfBirth')
                                        "
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    ref="picker"
                                    v-model="formFields.dateOfBirth"
                                    :max="
                                        new Date().toISOString().substr(0, 10)
                                    "
                                    min="1900-01-01"
                                    @change="saveDobField"
                                ></v-date-picker>
                            </v-menu>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.phone.show"
                        >
                            <label
                                for="phoneField"
                                v-if="
                                    !normalizedOptions.fields.phone.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.phone.label }}
                            </label>
                            <v-text-field
                                id="phoneField"
                                v-model="formFields.phone"
                                :label="
                                    normalizedOptions.fields.phone.inlineLabels
                                        ? normalizedOptions.fields.phone.label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.phone.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                type="phone"
                                :rules="
                                    normalizedOptions.fields.phone.required
                                        ? rules.phone
                                        : []
                                "
                                :error="getError('phone')"
                                :error-messages="getErrorMessages('phone')"
                                @input="removeErrorMessage('phone')"
                            ></v-text-field>
                        </div>

                        <div class="widget-eligibility-form-field">
                            <label
                                for="emailField"
                                v-if="
                                    !normalizedOptions.fields.email.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.email.label }}
                            </label>
                            <v-text-field
                                id="emailField"
                                v-model="formFields.email"
                                :label="
                                    normalizedOptions.fields.email.inlineLabels
                                        ? normalizedOptions.fields.email.label
                                        : ''
                                "
                                outlined
                                required
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="rules.email"
                                :error="getError('email')"
                                :error-messages="getErrorMessages('email')"
                                @input="removeErrorMessage('email')"
                            >
                                <template v-slot:message="{ message }">
                                    {{ message }}
                                    <a
                                        v-if="showVerifyEmail(message)"
                                        @click="getAccessMagicLink"
                                        href="#"
                                    >
                                        Alternatively, verify your email address
                                    </a>
                                </template>
                            </v-text-field>
                        </div>

                        <h2
                            v-if="
                                normalizedOptions.sections.livingSituation.title
                                    .show
                            "
                            :class="
                                normalizedOptions.sections.livingSituation.title
                                    .classes
                            "
                            :style="
                                normalizedOptions.sections.livingSituation.title
                                    .style
                            "
                        >
                            {{
                                normalizedOptions.sections.livingSituation.title
                                    .text
                            }}
                        </h2>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.livingCircumstance.show
                            "
                        >
                            <label
                                for="livingCircumstanceField"
                                v-if="
                                    !normalizedOptions.fields.livingCircumstance
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.livingCircumstance
                                        .label
                                }}
                            </label>

                            <v-select
                                id="livingCircumstanceField"
                                v-model="formFields.livingCircumstance"
                                :items="livingCircumstanceChoices"
                                item-text="name"
                                item-value="id"
                                :label="
                                    normalizedOptions.fields.livingCircumstance
                                        .inlineLabels
                                        ? normalizedOptions.fields
                                              .livingCircumstance.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields.livingCircumstance
                                        .required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.livingCircumstance
                                        .required
                                        ? rules.livingCircumstance
                                        : []
                                "
                                return-object
                                :error="getError('livingCircumstance')"
                                :error-messages="
                                    getErrorMessages('livingCircumstance')
                                "
                                @input="
                                    removeErrorMessage('livingCircumstance')
                                "
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.homeOwnershipStatus
                                    .show
                            "
                        >
                            <label
                                for="homeOwnershipStatusField"
                                v-if="
                                    !normalizedOptions.fields
                                        .homeOwnershipStatus.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.homeOwnershipStatus
                                        .label
                                }}
                            </label>
                            <v-select
                                id="homeOwnershipStatusField"
                                v-model="formFields.homeOwnershipStatus"
                                :items="homeOwnershipStatusChoices"
                                item-text="name"
                                item-value="id"
                                :label="
                                    normalizedOptions.fields.homeOwnershipStatus
                                        .inlineLabels
                                        ? normalizedOptions.fields
                                              .homeOwnershipStatus.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields.homeOwnershipStatus
                                        .required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.homeOwnershipStatus
                                        .required
                                        ? rules.homeOwnershipStatus
                                        : []
                                "
                                :error="getError('homeOwnershipStatus')"
                                :error-messages="
                                    getErrorMessages('homeOwnershipStatus')
                                "
                                @input="
                                    removeErrorMessage('homeOwnershipStatus')
                                "
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.dependants.show"
                        >
                            <label
                                for="dependantsField"
                                v-if="
                                    !normalizedOptions.fields.dependants
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.dependants.label }}
                            </label>
                            <v-text-field
                                id="dependantsField"
                                v-model.number="formFields.dependants"
                                type="number"
                                :label="
                                    normalizedOptions.fields.dependants
                                        .inlineLabels
                                        ? normalizedOptions.fields.dependants
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.dependants.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                min="0"
                                :rules="
                                    normalizedOptions.fields.dependants.required
                                        ? rules.dependants
                                        : []
                                "
                                :error="getError('dependants')"
                                :error-messages="getErrorMessages('dependants')"
                                @input="removeErrorMessage('dependants')"
                            ></v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.homePostcode.show"
                        >
                            <label
                                for="homePostcodeField"
                                v-if="
                                    !normalizedOptions.fields.homePostcode
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.homePostcode.label
                                }}
                            </label>
                            <v-text-field
                                id="homePostcodeField"
                                v-model="formFields.homePostcode"
                                :label="
                                    normalizedOptions.fields.homePostcode
                                        .inlineLabels
                                        ? normalizedOptions.fields.homePostcode
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.homePostcode
                                        .required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.homePostcode
                                        .required
                                        ? rules.homePostcode
                                        : []
                                "
                                :error="getError('homePostcode')"
                                :error-messages="
                                    getErrorMessages('homePostcode')
                                "
                                @input="removeErrorMessage('homePostcode')"
                            >
                                <template
                                    v-slot:append
                                    v-if="
                                        normalizedOptions.fields.homePostcode
                                            .help.show
                                    "
                                >
                                    <v-menu
                                        open-on-hover
                                        origin="center center"
                                        transition="scale-transition"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-help-box</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-card elevation="2" max-width="260">
                                            <v-card-text>
                                                {{
                                                    normalizedOptions.fields
                                                        .homePostcode.help.text
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.annualHouseholdIncome
                                    .show
                            "
                        >
                            <label
                                for="annualHouseholdIncomeField"
                                v-if="
                                    !normalizedOptions.fields
                                        .annualHouseholdIncome.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields
                                        .annualHouseholdIncome.label
                                }}
                            </label>
                            <v-text-field
                                id="annualHouseholdIncomeField"
                                v-model.number="
                                    formFields.annualHouseholdIncome
                                "
                                type="number"
                                :label="
                                    normalizedOptions.fields
                                        .annualHouseholdIncome.inlineLabels
                                        ? normalizedOptions.fields
                                              .annualHouseholdIncome.label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields
                                        .annualHouseholdIncome.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields
                                        .annualHouseholdIncome.required
                                        ? rules.annualHouseholdIncome
                                        : []
                                "
                                prefix="£"
                                min="0"
                                :error="getError('annualHouseholdIncome')"
                                :error-messages="
                                    getErrorMessages('annualHouseholdIncome')
                                "
                                @input="
                                    removeErrorMessage('annualHouseholdIncome')
                                "
                            >
                                <template
                                    v-slot:append
                                    v-if="
                                        normalizedOptions.fields
                                            .annualHouseholdIncome.help.show
                                    "
                                >
                                    <v-menu
                                        open-on-hover
                                        origin="center center"
                                        transition="scale-transition"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-help-box</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-card elevation="2" max-width="260">
                                            <v-card-text>
                                                {{
                                                    normalizedOptions.fields
                                                        .annualHouseholdIncome
                                                        .help.text
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.deposit.show"
                        >
                            <label
                                for="depositField"
                                v-if="
                                    !normalizedOptions.fields.deposit
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.deposit.label }}
                            </label>
                            <v-text-field
                                id="depositField"
                                v-model.number="formFields.deposit"
                                type="number"
                                :label="
                                    normalizedOptions.fields.deposit
                                        .inlineLabels
                                        ? normalizedOptions.fields.deposit.label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.deposit.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.deposit.required
                                        ? rules.deposit
                                        : []
                                "
                                prefix="£"
                                min="0"
                                :error="getError('deposit')"
                                :error-messages="getErrorMessages('deposit')"
                                @input="removeErrorMessage('deposit')"
                            >
                                <template
                                    v-slot:append
                                    v-if="
                                        normalizedOptions.fields.deposit.help
                                            .show
                                    "
                                >
                                    <v-menu
                                        open-on-hover
                                        transition="scale-transition"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-help-box</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-card elevation="2" max-width="260">
                                            <v-card-text>
                                                {{
                                                    normalizedOptions.fields
                                                        .deposit.help.text
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>

                        <h2
                            v-if="
                                normalizedOptions.sections.workSituation.title
                                    .show
                            "
                            :class="
                                normalizedOptions.sections.workSituation.title
                                    .classes
                            "
                            :style="
                                normalizedOptions.sections.workSituation.title
                                    .style
                            "
                        >
                            {{
                                normalizedOptions.sections.workSituation.title
                                    .text
                            }}
                        </h2>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.workingCircumstance
                                    .show
                            "
                        >
                            <label
                                for="workingCircumstanceField"
                                v-if="
                                    !normalizedOptions.fields
                                        .workingCircumstance.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.workingCircumstance
                                        .label
                                }}
                            </label>
                            <v-select
                                id="workingCircumstanceField"
                                v-model="formFields.workingCircumstance"
                                :items="workingCircumstanceChoices"
                                item-text="name"
                                item-value="id"
                                :label="
                                    normalizedOptions.fields.workingCircumstance
                                        .inlineLabels
                                        ? normalizedOptions.fields
                                              .workingCircumstance.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields.workingCircumstance
                                        .required
                                "
                                return-object
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.workingCircumstance
                                        .required
                                        ? rules.workingCircumstance
                                        : []
                                "
                                :error="getError('workingCircumstance')"
                                :error-messages="
                                    getErrorMessages('workingCircumstance')
                                "
                                @input="
                                    removeErrorMessage('workingCircumstance')
                                "
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.occupation.show &&
                                formFields.workingCircumstance &&
                                formFields.workingCircumstance.working
                            "
                        >
                            <label
                                for="occupationField"
                                v-if="
                                    !normalizedOptions.fields.occupation
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.occupation.label }}
                            </label>
                            <v-text-field
                                id="occupationField"
                                v-model="formFields.occupation"
                                :label="
                                    normalizedOptions.fields.occupation
                                        .inlineLabels
                                        ? normalizedOptions.fields.occupation
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.occupation.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.occupation.required
                                        ? rules.occupation
                                        : []
                                "
                                :error="getError('occupation')"
                                :error-messages="getErrorMessages('occupation')"
                                @input="removeErrorMessage('occupation')"
                            ></v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.employerName.show &&
                                formFields.workingCircumstance &&
                                formFields.workingCircumstance.working
                            "
                        >
                            <label
                                for="employerNameField"
                                v-if="
                                    !normalizedOptions.fields.employerName
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.employerName.label
                                }}
                            </label>
                            <v-text-field
                                id="employerNameField"
                                v-model="formFields.employerName"
                                :label="
                                    normalizedOptions.fields.employerName
                                        .inlineLabels
                                        ? normalizedOptions.fields.employerName
                                              .label
                                        : ''
                                "
                                outlined
                                :required="
                                    normalizedOptions.fields.employerName
                                        .required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.employerName
                                        .required
                                        ? rules.employerName
                                        : []
                                "
                                :error="getError('employerName')"
                                :error-messages="
                                    getErrorMessages('employerName')
                                "
                                @input="removeErrorMessage('employerName')"
                            ></v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                (normalizedOptions.validateEligibility &&
                                    isFieldInCollection(
                                        'workPostcode',
                                        'eligibilityFields'
                                    )) ||
                                (normalizedOptions.fields.workPostcode.show &&
                                    formFields.workingCircumstance &&
                                    formFields.workingCircumstance.working)
                            "
                        >
                            <label
                                for="workPostcodeField"
                                v-if="
                                    !normalizedOptions.fields.workPostcode
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.workPostcode.label
                                }}
                            </label>
                            <v-text-field
                                id="workPostcodeField"
                                v-model="formFields.workPostcode"
                                :label="
                                    normalizedOptions.fields.workPostcode
                                        .inlineLabels
                                        ? normalizedOptions.fields.workPostcode
                                              .label
                                        : ''
                                "
                                outlined
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :required="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'workPostcode',
                                            'eligibilityFields'
                                        )) ||
                                    normalizedOptions.fields.workPostcode
                                        .required
                                        ? true
                                        : false
                                "
                                :rules="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'workPostcode',
                                            'eligibilityFields'
                                        )) ||
                                    normalizedOptions.fields.workPostcode
                                        .required
                                        ? rules.workPostcode
                                        : []
                                "
                                :error="getError('workPostcode')"
                                :error-messages="
                                    getErrorMessages('workPostcode')
                                "
                                @input="removeErrorMessage('workPostcode')"
                            >
                                <template
                                    v-slot:append
                                    v-if="
                                        normalizedOptions.fields.workPostcode
                                            .help.show
                                    "
                                >
                                    <v-menu
                                        open-on-hover
                                        origin="center center"
                                        transition="scale-transition"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                v-bind="attrs"
                                                v-on="on"
                                            >
                                                <v-icon>mdi-help-box</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-card elevation="2" max-width="260">
                                            <v-card-text>
                                                {{
                                                    normalizedOptions.fields
                                                        .workPostcode.help.text
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-menu>
                                </template>
                            </v-text-field>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                (normalizedOptions.validateEligibility &&
                                    isFieldInCollection(
                                        'armedForcesMember',
                                        'priorityFields'
                                    )) ||
                                normalizedOptions.fields.armedForcesMember.show
                            "
                        >
                            <label
                                for="armedForcesMemberField"
                                v-if="
                                    !normalizedOptions.fields.armedForcesMember
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.armedForcesMember
                                        .label
                                }}
                            </label>
                            <v-select
                                id="armedForcesMemberField"
                                v-model="formFields.armedForcesMember"
                                :items="armedForcesMemberChoices"
                                :label="
                                    normalizedOptions.fields.armedForcesMember
                                        .inlineLabels
                                        ? normalizedOptions.fields
                                              .armedForcesMember.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'armedForcesMember',
                                            'priorityFields'
                                        )) ||
                                    normalizedOptions.fields.armedForcesMember
                                        .required
                                        ? true
                                        : false
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'armedForcesMember',
                                            'priorityFields'
                                        )) ||
                                    normalizedOptions.fields.armedForcesMember
                                        .required
                                        ? rules.armedForcesMember
                                        : []
                                "
                                :error="getError('armedForcesMember')"
                                :error-messages="
                                    getErrorMessages('armedForcesMember')
                                "
                                @input="removeErrorMessage('armedForcesMember')"
                            ></v-select>
                        </div>

                        <h2
                            v-if="
                                normalizedOptions.sections.additionalInformation
                                    .title.show
                            "
                            :class="
                                normalizedOptions.sections.additionalInformation
                                    .title.classes
                            "
                            :style="
                                normalizedOptions.sections.additionalInformation
                                    .additionalInformation.style
                            "
                        >
                            {{
                                normalizedOptions.sections.additionalInformation
                                    .title.text
                            }}
                        </h2>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                (normalizedOptions.validateEligibility &&
                                    isFieldInCollection(
                                        'eligibleCitizen',
                                        'eligibilityFields'
                                    )) ||
                                normalizedOptions.fields.eligibleCitizen.show
                            "
                        >
                            <label
                                for="eligibleCitizenField"
                                v-if="
                                    !normalizedOptions.fields.eligibleCitizen
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.eligibleCitizen
                                        .label
                                }}
                            </label>
                            <v-select
                                id="eligibleCitizenField"
                                v-model="formFields.eligibleCitizen"
                                :items="eligibleCitizenChoices"
                                :label="
                                    normalizedOptions.fields.eligibleCitizen
                                        .inlineLabels
                                        ? normalizedOptions.fields
                                              .eligibleCitizen.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'eligibleCitizen',
                                            'eligibilityFields'
                                        )) ||
                                    normalizedOptions.fields.eligibleCitizen
                                        .required
                                        ? true
                                        : false
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'eligibleCitizen',
                                            'eligibilityFields'
                                        )) ||
                                    normalizedOptions.fields.eligibleCitizen
                                        .required
                                        ? rules.eligibleCitizen
                                        : []
                                "
                                :error="getError('eligibleCitizen')"
                                :error-messages="
                                    getErrorMessages('eligibleCitizen')
                                "
                                @input="removeErrorMessage('eligibleCitizen')"
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                (normalizedOptions.validateEligibility &&
                                    isFieldInCollection(
                                        'hasDisability',
                                        'priorityFields'
                                    )) ||
                                normalizedOptions.fields.hasDisability.show
                            "
                        >
                            <label
                                for="hasDisabilityField"
                                v-if="
                                    !normalizedOptions.fields.hasDisability
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields.hasDisability.label
                                }}
                            </label>
                            <v-select
                                id="hasDisabilityField"
                                v-model="formFields.hasDisability"
                                :items="hasDisabilityChoices"
                                :label="
                                    normalizedOptions.fields.hasDisability
                                        .inlineLabels
                                        ? normalizedOptions.fields.hasDisability
                                              .label
                                        : ''
                                "
                                outlined
                                clearable
                                hide-details="auto"
                                :required="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'hasDisability',
                                            'priorityFields'
                                        )) ||
                                    normalizedOptions.fields.hasDisability
                                        .required
                                        ? true
                                        : false
                                "
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    (normalizedOptions.validateEligibility &&
                                        isFieldInCollection(
                                            'hasDisability',
                                            'priorityFields'
                                        )) ||
                                    normalizedOptions.fields.hasDisability
                                        .required
                                        ? rules.hasDisability
                                        : []
                                "
                                :error="getError('hasDisability')"
                                :error-messages="
                                    getErrorMessages('hasDisability')
                                "
                                @input="removeErrorMessage('hasDisability')"
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.bestTimeToContactYou
                                    .show
                            "
                        >
                            <label
                                for="bestTimeToContactYouField"
                                v-if="
                                    !normalizedOptions.fields
                                        .bestTimeToContactYou.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields
                                        .bestTimeToContactYou.label
                                }}
                            </label>
                            <v-select
                                id="bestTimeToContactYouField"
                                v-model="formFields.bestTimeToContactYou"
                                :items="bestTimeToContactChoices"
                                item-text="name"
                                item-value="id"
                                :label="
                                    normalizedOptions.fields
                                        .bestTimeToContactYou.inlineLabels
                                        ? normalizedOptions.fields
                                              .bestTimeToContactYou.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields
                                        .bestTimeToContactYou.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields
                                        .bestTimeToContactYou.required
                                        ? rules.bestTimeToContactYou
                                        : []
                                "
                                :error="getError('bestTimeToContactYou')"
                                :error-messages="
                                    getErrorMessages('bestTimeToContactYou')
                                "
                                @input="
                                    removeErrorMessage('bestTimeToContactYou')
                                "
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.buyingInterestPeriod
                                    .show
                            "
                        >
                            <label
                                for="buyingInterestPeriodField"
                                v-if="
                                    !normalizedOptions.fields
                                        .buyingInterestPeriod.inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{
                                    normalizedOptions.fields
                                        .buyingInterestPeriod.label
                                }}
                            </label>
                            <v-select
                                v-model="formFields.buyingInterestPeriod"
                                :items="buyingInterestPeriodChoices"
                                item-text="name"
                                item-value="id"
                                :label="
                                    normalizedOptions.fields
                                        .buyingInterestPeriod.inlineLabels
                                        ? normalizedOptions.fields
                                              .buyingInterestPeriod.label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields
                                        .buyingInterestPeriod.required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields
                                        .buyingInterestPeriod.required
                                        ? rules.buyingInterestPeriod
                                        : []
                                "
                                :error="getError('buyingInterestPeriod')"
                                :error-messages="
                                    getErrorMessages('buyingInterestPeriod')
                                "
                                @input="
                                    removeErrorMessage('buyingInterestPeriod')
                                "
                            ></v-select>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="normalizedOptions.fields.hearAboutUs.show"
                        >
                            <label
                                for="hearAboutUsField"
                                v-if="
                                    !normalizedOptions.fields.hearAboutUs
                                        .inlineLabels
                                "
                                class="mb-4 font-weight-bold"
                            >
                                {{ normalizedOptions.fields.hearAboutUs.label }}
                            </label>
                            <v-select
                                id="hearAboutUsField"
                                v-model="formFields.hearAboutUs"
                                :items="
                                    has(
                                        normalizedOptions,
                                        'fields.hearAboutUs.items'
                                    )
                                        ? normalizedOptions.fields.hearAboutUs
                                              .items
                                        : []
                                "
                                item-text="name"
                                item-value="name"
                                :label="
                                    normalizedOptions.fields.hearAboutUs
                                        .inlineLabels
                                        ? normalizedOptions.fields.hearAboutUs
                                              .label
                                        : ''
                                "
                                outlined
                                clearable
                                :required="
                                    normalizedOptions.fields.hearAboutUs
                                        .required
                                "
                                hide-details="auto"
                                class="rounded-0 mb-4"
                                background-color="white"
                                :rules="
                                    normalizedOptions.fields.hearAboutUs
                                        .required
                                        ? rules.hearAboutUs
                                        : []
                                "
                                :error="getError('hearAboutUs')"
                                :error-messages="
                                    getErrorMessages('hearAboutUs')
                                "
                                @input="removeErrorMessage('hearAboutUs')"
                            ></v-select>
                        </div>

                        <h2
                            v-if="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.title.show
                            "
                            :class="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.title.classes
                            "
                            :style="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.title.style
                            "
                        >
                            {{
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.title.text
                            }}
                        </h2>
                        <div
                            v-if="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.intro.show
                            "
                            :class="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.intro.classes
                            "
                            :style="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.intro.style
                            "
                            v-html="
                                normalizedOptions.sections
                                    .privacyPolicyAndNotifications.intro
                                    .textHtml
                            "
                        ></div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.newsletterConsent.show
                            "
                        >
                            <v-checkbox
                                v-model="formFields.newsletterConsent"
                                :label="
                                    normalizedOptions.fields.newsletterConsent
                                        .label
                                "
                                class="rounded-0 mb-4"
                                hide-details="auto"
                                :required="
                                    normalizedOptions.fields.newsletterConsent
                                        .required
                                "
                                :rules="
                                    normalizedOptions.fields.newsletterConsent
                                        .required
                                        ? rules.newsletterConsent
                                        : []
                                "
                                :error="getError('newsletterConsent')"
                                :error-messages="
                                    getErrorMessages('newsletterConsent')
                                "
                            ></v-checkbox>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.newsSurveysConsent.show
                            "
                        >
                            <v-checkbox
                                v-model="formFields.newsSurveysConsent"
                                :label="
                                    normalizedOptions.fields.newsSurveysConsent
                                        .label
                                "
                                class="rounded-0 mb-4"
                                :required="
                                    normalizedOptions.fields.newsSurveysConsent
                                        .required
                                "
                                :rules="
                                    normalizedOptions.fields.newsSurveysConsent
                                        .required
                                        ? rules.newsSurveysConsent
                                        : []
                                "
                                :error="getError('newsSurveysConsent')"
                                :error-messages="
                                    getErrorMessages('newsSurveysConsent')
                                "
                                hide-details="auto"
                            ></v-checkbox>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="
                                normalizedOptions.fields.partnersOffersConsent
                                    .show
                            "
                        >
                            <v-checkbox
                                v-model="formFields.partnersOffersConsent"
                                :label="
                                    normalizedOptions.fields
                                        .partnersOffersConsent.label
                                "
                                class="rounded-0 mb-4"
                                hide-details="auto"
                                :required="
                                    normalizedOptions.fields
                                        .partnersOffersConsent.required
                                "
                                :rules="
                                    normalizedOptions.fields
                                        .partnersOffersConsent.required
                                        ? rules.partnersOffersConsent
                                        : []
                                "
                                :error="getError('partnersOffersConsent')"
                                :error-messages="
                                    getErrorMessages('partnersOffersConsent')
                                "
                            ></v-checkbox>
                        </div>

                        <div
                            class="widget-eligibility-form-field"
                            v-if="housingProviderName === 'Settle'"
                        >
                            <p>
                                I confirm I’m happy for settle to contact me
                                via:
                            </p>

                            <v-checkbox
                                v-for="(
                                    extraConsent, i
                                ) in extraMarketingInfoArray"
                                v-model="selected"
                                :key="i"
                                :value="extraConsent.value"
                                :label="extraConsent.text"
                                :rules="rules.extraMarketing"
                            ></v-checkbox>
                        </div>

                        <div class="widget-eligibility-form-field">
                            <v-checkbox
                                v-model="formFields.privacyPolicyAccepted"
                                :label="
                                    normalizedOptions.fields
                                        .privacyPolicyAccepted.label
                                "
                                required
                                class="rounded-0 mb-4"
                                hide-details="auto"
                                :rules="rules.privacyPolicyAccepted"
                                :error="getError('privacyPolicyAccepted')"
                                :error-messages="
                                    getErrorMessages('privacyPolicyAccepted')
                                "
                            >
                                <template v-slot:label>
                                    <div>
                                        I agree to
                                        {{
                                            housingProviderName !== ""
                                                ? housingProviderName
                                                : "the"
                                        }}
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <a
                                                    target="_blank"
                                                    :href="
                                                        normalizedOptions.fields
                                                            .privacyPolicyAccepted
                                                            .linkToPolicy
                                                    "
                                                    @click.stop
                                                    v-on="on"
                                                >
                                                    privacy policy
                                                </a>
                                            </template>
                                            Opens in new window
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-checkbox>
                        </div>

                        <div class="widget-eligibility-form-field">
                            <v-btn
                                :loading="sendingForm"
                                @click="validateForm"
                                block
                                color="primary"
                                class="rounded-0 mb-4"
                            >
                                {{ normalizedOptions.fields.submit.text }}
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <v-dialog
            v-model="responseDialog.show"
            persistent
            max-width="1280px"
            class="widget-component"
        >
            <v-card>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <div class="my-12 pt-16 text-center">
                                    <div
                                        v-if="responseDialog.icon.show"
                                        class="mx-auto mb-12"
                                    >
                                        <v-icon
                                            :size="responseDialog.icon.size"
                                        >
                                            {{ responseDialog.icon.icon }}
                                        </v-icon>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="responseDialog.header.show"
                                    >
                                        <h1 v-if="responseDialog.header.text">
                                            {{ responseDialog.header.text }}
                                        </h1>
                                    </div>

                                    <div
                                        class="mx-auto mb-6"
                                        v-if="responseDialog.body.show"
                                        v-html="responseDialog.body.text"
                                    ></div>

                                    <div class="mx-auto">
                                        <v-btn
                                            :color="
                                                responseDialog.closeButton.color
                                            "
                                            @click="closeResponseDialog"
                                            v-if="
                                                responseDialog.closeButton.show
                                            "
                                        >
                                            Close
                                        </v-btn>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import {
    defineComponent,
    ref,
    onMounted,
    computed,
    watch,
    nextTick,
} from "@vue/composition-api";
import {
    merge,
    has,
    isNumber,
    includes,
    isNil,
    find,
    cloneDeep,
    forEach,
    clone,
    isEmpty,
} from "lodash";
import ListingCard from "./ListingCard.vue";
import MainMenu from "./partials/MainMenu";
import HelperServices from "../services/HelperServices";
import ListingService from "../services/ListingService";
import PropertyService from "../services/PropertyService";
import ProfileService from "../services/ProfileService";
import ProfileState from "../state/ProfileState";
import AuthenticationService from "../services/AuthenticationService";
import AuthenticationState from "../state/AuthenticationState";

export default defineComponent({
    name: "EligibilityForm",
    components: { ListingCard, MainMenu },
    props: {
        rootUrl: {
            type: String,
            required: true,
        },
        listingSlug: {
            type: String,
            required: true,
        },
        propertyId: {
            type: String,
        },
        accessToken: {
            type: String,
        },
        housingProviderName: {
            type: String,
            default: "",
        },
        settings: {
            type: Object
        },
        emailVerificationUrl: {
            type: String
        }
    },
    setup(props, context) {
        const token = ref(null);
        const loading = ref(false);
        const form = ref(null);
        const formValid = ref(false);
        const listing = ref({});
        const property = ref({});
        const checkEligibility = ref(null);
        const properties = ref([]);
        const formFields = ref({});
        const sendingForm = ref(false);
        const formKey = ref(0);

        const defaultSettings = ref({
            validateEligibility: false,
            title: {
                show: true,
                text: "Register your interest",
                style: "",
                classes: "mb-4 color-primary",
            },
            intro: {
                show: true,
                textHtml:
                    "<p>Registering your interest or checking your eligibility means the information you provide will be passed to the housing provider, so that they can contact you by email or telephone about your application.</p><p>This is not a credit check or full eligibility test.</p>",
                classes: "",
                style: "",
            },
            sections: {
                personalInformation: {
                    title: {
                        show: false,
                        text: "Personal information",
                        style: "",
                        classes: "mt-10 mb-4",
                    },
                },
                livingSituation: {
                    title: {
                        show: false,
                        text: "Living situation",
                        style: "",
                        classes: "",
                    },
                },
                workSituation: {
                    title: {
                        show: false,
                        text: "Work situation",
                        style: "",
                        classes: "",
                    },
                },
                additionalInformation: {
                    title: {
                        show: false,
                        text: "Additional information",
                        style: "",
                        classes: "mt-10 mb-4",
                    },
                },
                privacyPolicyAndNotifications: {
                    title: {
                        show: false,
                        text: "Privacy policy and notifications",
                        style: "",
                        classes: "mt-10 mb-4",
                    },
                    intro: {
                        show: true,
                        textHtml:
                            "<p>Before you make an enquiry...<br/>We want you to know that by submitting this from we will share your details with the housingprovider and / or their respective agent in order for them to contact you in response to your interest.<br/>Please see our privacy policy for more details on how we use your personal data.</p>",
                        classes: "",
                        style: "",
                    },
                },
            },
            fields: {
                title: {
                    show: false,
                    label: "Title",
                    inlineLabels: false,
                    required: false,
                },
                firstName: {
                    show: true,
                    label: "First name *",
                    inlineLabels: false,
                    required: true,
                },
                lastName: {
                    show: true,
                    label: "Last name *",
                    inlineLabels: false,
                    required: true,
                },
                dateOfBirth: {
                    show: false,
                    label: "Date of Birth",
                    inlineLabels: false,
                    required: false,
                },
                phone: {
                    show: true,
                    label: "Phone number *",
                    inlineLabels: false,
                    required: true,
                },
                email: {
                    label: "Email address *",
                    inlineLabels: false,
                },
                livingCircumstance: {
                    show: false,
                    label: "Current living situation",
                    inlineLabels: false,
                    required: false,
                },
                hearAboutUs: {
                    show: false,
                    label: "How did you hear about us?",
                    inlineLabels: false,
                    required: false,
                    items: [
                        { name: "Blog or publication" },
                        { name: "Email" },
                        { name: "Facebook" },
                        { name: "Instagram" },
                        { name: "Keaze" },
                        { name: "Newspaper / Magazine" },
                        { name: "Online advert" },
                        { name: "OnTheMarket" },
                        { name: "Poster/billboard" },
                        { name: "Recommended by friend/family/colleague" },
                        { name: "Rightmove" },
                        { name: "Search engine (e.g. Google, Bing, etc.)" },
                        { name: "Share to buy" },
                        { name: "Twitter" },
                        { name: "Youtube" },
                        { name: "Zoopla" },
                        { name: "Other" },
                    ],
                },
                selected: {
                    show: true,
                    label: "select one of these",
                },
                homeOwnershipStatus: {
                    show: false,
                    label: "Home ownership status",
                    inlineLabels: false,
                    required: false,
                },
                dependants: {
                    show: false,
                    label: "Dependants",
                    inlineLabels: false,
                    required: false,
                },
                homePostcode: {
                    show: false,
                    label: "Current postcode",
                    inlineLabels: false,
                    required: false,
                    help: {
                        show: true,
                        text: "Tell us the postcode for where you live at the moment.",
                    },
                },
                annualHouseholdIncome: {
                    show: false,
                    label: "Household income",
                    inlineLabels: false,
                    required: false,
                    help: {
                        show: true,
                        text: "Tell us the total income before tax, of everyone who will be buying the home.",
                    },
                },
                deposit: {
                    show: false,
                    label: "Deposit",
                    inlineLabels: false,
                    required: false,
                    help: {
                        show: true,
                        text: "Tell us the amount of savings you are planning to put toward your deposit.",
                    },
                },
                workingCircumstance: {
                    show: false,
                    label: "Working circumstance",
                    inlineLabels: false,
                    required: false,
                },
                occupation: {
                    show: false,
                    label: "Occupation",
                    inlineLabels: false,
                    required: false,
                },
                employerName: {
                    show: false,
                    label: "Employer name",
                    inlineLabels: false,
                    required: false,
                },
                workPostcode: {
                    show: false,
                    label: "Work postcode",
                    inlineLabels: false,
                    required: false,
                    help: {
                        show: true,
                        text: "Tell us the postcode of where you normally go to work.",
                    },
                },
                armedForcesMember: {
                    show: false,
                    label: "Are you a member of the armed forces?",
                    inlineLabels: false,
                    required: false,
                },
                eligibleCitizen: {
                    show: false,
                    label: "Are you a British, EU/EEA citizen or have ILR?",
                    inlineLabels: false,
                    required: false,
                },
                hasDisability: {
                    show: false,
                    label: "Do you have any known disability?",
                    inlineLabels: false,
                    required: false,
                },
                bestTimeToContactYou: {
                    show: false,
                    label: "Best time to contact",
                    inlineLabels: false,
                    required: false,
                },
                buyingInterestPeriod: {
                    show: false,
                    label: "Buying interest period",
                    inlineLabels: false,
                    required: false,
                },
                privacyPolicyAccepted: {
                    label: `I agree to ${
                        props.housingProviderName !== ""
                            ? props.housingProviderName
                            : "the"
                    }  privacy policy`,
                    linkToPolicy: "/privacy-policy",
                },

                WhatsAppConsent: {
                    show: true,
                },

                newsletterConsent: {
                    show: true,
                    label: "I want to receive alerts about other relevant properties",
                    required: false,
                },
                newsSurveysConsent: {
                    show: true,
                    label: "I want to receive information relating to relevant news and surveys",
                    required: false,
                },
                partnersOffersConsent: {
                    show: true,
                    label: `I want to receive information and offers from ${
                        props.housingProviderName !== ""
                            ? props.housingProviderName
                            : "the"
                    } chosen partners`,
                    required: false,
                },

                submit: {
                    text: "Register interest",
                },
            },
            events: {
                successfulRegisterInterest: {
                    headerText: "Your interest has been registered",
                    bodyHtml:
                        "<p>We have passed your enquiry to our sales team</p><p>Please check your email for more information.</p>",
                    icon: "mdi-text-box-check-outline",
                    displayFullResponse: false,
                },
            },
        });

        const extraMarketingInfoArray = ref([
            { text: "WhatsApp", value: "WhatsApp" },
            { text: "Email", value: "Email" },
            { text: "SMS", value: "SMS" },
            { text: "Phone", value: "Phone" },
        ]);

        const selected = ref([]);

        const titleChoices = ref([
            { text: "Mr", value: "mr" },
            { text: "Mrs", value: "mrs" },
            { text: "Miss", value: "miss" },
            { text: "Ms", value: "ms" },
            { text: "Mx", value: "mx" },
            { text: "Dr", value: "dr" },
            { text: "Sir", value: "sir" },
            { text: "Other", value: "other" },
        ]);
        const armedForcesMemberChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const eligibleCitizenChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const hasDisabilityChoices = ref([
            { text: "Yes", value: 1 },
            { text: "No", value: 0 },
        ]);
        const homeOwnershipStatusChoices = ref([
            {
                name: "I'm a first time buyer",
                id: 1,
                owner: false,
                disabled: false,
            },
            {
                name: "I do not own any property at the moment",
                id: 2,
                owner: false,
                disabled: false,
            },
            {
                name: "I own a property but it's currently in a selling process",
                id: 3,
                owner: true,
                disabled: false,
            },
            {
                name: "I own one or more properties",
                id: 4,
                owner: true,
                disabled: false,
            },
        ]);

        const showDatePicker = ref(false);
        const picker = ref(null);
        const menu = ref(null);
        const working = ref(true);

        const livingCircumstanceChoices = ref([]);
        const workingCircumstanceChoices = ref([]);
        const buyingInterestPeriodChoices = ref([]);
        const bestTimeToContactChoices = ref([]);

        const registerInterestFields = ref([]);
        const formResponse = ref({});

        const rules = ref({
            title: [(v) => !!v || "Title is required"],
            firstName: [(v) => !!v || "First name is required"],
            lastName: [(v) => !!v || "Last name is required"],
            dateOfBirth: [(v) => !!v || "Date of birth is required"],
            phone: [
                (v) => !!v || "Phone number is required",
                (v) =>
                    /^[0-9]*$/.test(v) || "Please enter a valid phone number",
            ],
            email: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+/.test(v) || "E-mail must be valid",
            ],
            livingCircumstance: [(v) => !!v || "Required"],
            homeOwnershipStatus: [(v) => !!v || "Required"],
            dependants: [(v) => v >= 0 || "Value must be 0 or greater then 0"],
            homePostcode: [(v) => !!v || "Home postcode is required"],
            annualHouseholdIncome: [
                (v) => v >= 0 || "Value must be 0 or greater then 0",
            ],
            deposit: [(v) => v >= 0 || "Value must be 0 or greater then 0"],
            workingCircumstance: [
                (v) => !!v || "Working circumstance is required",
            ],
            occupation: [(v) => !!v || "Occupation is required"],
            employerName: [(v) => !!v || "Employer name is required"],
            workPostcode: [
                (v) =>
                    isFieldInCollection("workPostcode", "eligibilityFields") ==
                        false || "Work postcode is required",
            ],
            armedForcesMember: [],
            eligibleCitizen: [],
            hasDisability: [],
            bestTimeToContactYou: [(v) => !!v || "Required"],
            buyingInterestPeriod: [(v) => !!v || "Required"],
            privacyPolicyAccepted: [(v) => !!v || "Required"],
            newsletterConsent: [],
            newsSurveysConsent: [],
            partnersOffersConsent: [],
            extraMarketing: [
                (v) =>
                    v.length > 0 ||
                    "Please select one of these contact methods.",
            ],
        });

        const validationErrors = ref([]);

        const loginDialog = ref(false);

        const responseDialog = ref({
            show: false,
            icon: {
                show: true,
                size: 112,
                icon: "mdi-text-box-check-outline",
            },
            header: {
                show: true,
                text: "Your interest has been registered",
            },
            body: {
                show: true,
                text: "<p>We have passed your enquiry to ....</p><p>Please check your email for more information</p>",
            },
            closeButton: {
                show: true,
                color: "primary",
            },
        });

        const accessToken = ref(null);
        const loggedInProfile = ref(null);

        const normalizedOptions = computed(() => {
            return merge(defaultSettings.value, props.settings);
        });

        const loggedIn = computed(() => {
            if (accessToken.value !== null) {
                return true;
            }
            return false;
        });

        const listingImage = computed(() => {
            if (listing.value.galleryImages) {
                return find(listing.value.galleryImages, function (o) {
                    return o.main === true;
                });
            }
            return false;
        });

        const listingUrl = computed(() => {
            if (listing.value.slug) {
                return props.rootUrl + "/listing/" + listing.value.slug;
            }
            return "";
        });

        const dateOfBirthFormatted = computed(() => {
            return formatDate(formFields.value.dateOfBirth);
        });

        const currencyFormatter = new Intl.NumberFormat("gb-GB", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

        watch(showDatePicker, (currentValue) => {
            currentValue &&
                setTimeout(() => (picker.value.activePicker = "YEAR"));
        });

        watch(
            () => cloneDeep(formFields.value.livingCircumstance),
            (currentValue) => {
                forEach(homeOwnershipStatusChoices.value, function (value) {
                    if (value.owner === false && currentValue.owner === true) {
                        value.disabled = true;
                        formFields.value.homeOwnershipStatus = "";
                    } else {
                        value.disabled = false;
                    }
                });
            }
        );

        function fetchListing() {
            loading.value = true;
            if (isNumber(props.propertyId) && props.listingSlug) {
                PropertyService.getRegisterInterestFieldsWithPropertyDetails()
                    .then(function (response) {
                        if (response.data.registerInterestFields) {
                            registerInterestFields.value =
                                response.data.registerInterestFields;
                        }
                        if (response.data.listing) {
                            listing.value = response.data.listing;
                        }
                        if (response.data.property) {
                            property.value = response.data.property;
                        }
                        if (response.data.properties) {
                            properties.value = response.data.properties;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                        loading.value = false;
                    });
            } else if (props.listingSlug) {
                ListingService.getRegisterInterestFieldsWithListingDetails(
                    props.listingSlug
                )
                    .then(function (response) {
                        if (response.data.registerInterestFields) {
                            registerInterestFields.value =
                                response.data.registerInterestFields;
                        }
                        if (response.data.listing) {
                            listing.value = response.data.listing;
                        }
                        if (response.data.property) {
                            property.value = response.data.property;
                        }
                        if (response.data.properties) {
                            properties.value = response.data.properties;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    })
                    .then(function () {
                        loading.value = false;
                    });
            } else {
                throw "Listing/Property not found";
            }
        }

        function saveDobField(date) {
            menu.value.save(date);
        }

        function isFieldInCollection(fieldName, fieldType) {
            return includes(registerInterestFields.value[fieldType], fieldName);
        }

        function validateForm() {
            let valid = form.value.validate();
            if (valid) {
                submitForm();
            } else {
                nextTick(() => {
                    const target = document.querySelector(
                        ".v-messages.error--text:first-of-type"
                    );
                    scrollToElement(target, 300, 72);
                });
            }
        }

        function showVerifyEmail(message) {
            return (
                props.emailVerificationUrl &&
                message.includes('has already been taken')
            );
        }

        function magicLinkRequestErrors(error) {
            if (has(error.response.data, 'errors')) {
                let content = '';

                for (let field in error.response.data.errors) {
                    content += '<p>' + error.response.data.errors[field].join('</p><p>') + '</p>';
                }
                return content;
            }
            return '<p>' + error.response.data.message + '</p>';
        }

        function getAccessMagicLink(event) {
            event.preventDefault();
            let url = props.emailVerificationUrl.substring(0, props.emailVerificationUrl.indexOf('{id}'));
            AuthenticationService.passwordlessAccess(formFields.value.email, url)
                .then(response => {
                    responseDialog.value = {
                        show: true,
                        icon: {
                            show: true,
                            size: 112,
                            icon: 'mdi-information-outline'
                        },
                        header: {
                            show: true,
                            text: 'Check your email'
                        },
                        body: {
                            show: true,
                            text: '<p>We have emailed you a link to confirm your email address</p>'
                        },
                        closeButton: {
                            show: true,
                            color: 'primary'
                        }
                    };
                })
                .catch(error => {
                    responseDialog.value = {
                        show: true,
                        icon: {
                            show: true,
                            size: 112,
                            icon: 'mdi-information-outline'
                        },
                        header: {
                            show: true,
                            text: 'Sorry, an unexpected error has occurred'
                        },
                        body: {
                            show: true,
                            text: magicLinkRequestErrors(error)
                        },
                        closeButton: {
                            show: true,
                            color: 'primary'
                        }
                    };
                });
        }

        function submitForm() {
            let payload = buildPayload();
            // console.log(payload);
            loading.value = true;
            sendingForm.value = true;
            const loggedIn = !isNil(loggedInProfile.value) || !isNil(AuthenticationState.accessToken.value);

            ProfileService.registerInterestBySlug(
                props.listingSlug,
                payload,
                loggedIn
            )
                .then(function (response) {
                    formResponse.value = response.data;
                    if (response.status == 201) {
                        let icon =
                            normalizedOptions.value.events
                                .successfulRegisterInterest.icon;
                        let headerText =
                            normalizedOptions.value.events
                                .successfulRegisterInterest.headerText;
                        let bodyText =
                            normalizedOptions.value.events
                                .successfulRegisterInterest.bodyHtml;
                        if (
                            normalizedOptions.value.events
                                .successfulRegisterInterest.displayFullResponse
                                .value == true
                        ) {
                            if (response.data.decision.status == "failed") {
                                icon = "mdi-text-box-remove-outline";
                                headerText = "Unsuccessful";
                                bodyText = "";
                                if (
                                    response.data.decision.messages &&
                                    response.data.decision.messages.length > 0
                                ) {
                                    forEach(
                                        response.data.decision.messages,
                                        function (value) {
                                            bodyText += "<p>" + value + "</p>";
                                        }
                                    );
                                }
                            }
                        }
                        responseDialog.value = {
                            show: true,
                            icon: {
                                show: true,
                                size: 112,
                                icon: icon,
                            },
                            header: {
                                show: true,
                                text: headerText,
                            },
                            body: {
                                show: true,
                                text: bodyText,
                            },
                            closeButton: {
                                show: true,
                                color: "primary",
                            },
                        };
                    }
                    context.emit(
                        "registerInterestFormSubmitted",
                        formResponse.value
                    );
                })
                .catch(function (error) {
                    if (error.response.status == 422) {
                        validationErrors.value = error.response.data;
                        //Scroll to error
                        nextTick(() => {
                            const target = document.querySelector(
                                ".v-messages.error--text:first-of-type"
                            );
                            scrollToElement(target, 300, 72);
                        });
                    }
                    // response code: 409 -> duplication
                    else if (error.response.status == 409) {
                        let headerText =
                            "Your interest has already been registered";
                        let bodyText =
                            "<p>" + error.response.data.message + "</p>";
                        if (
                            has(
                                normalizedOptions.value,
                                "events.duplicatedInterest.header.text"
                            )
                        ) {
                            headerText =
                                normalizedOptions.value.events
                                    .duplicatedInterest.header.text;
                        }
                        if (
                            has(
                                normalizedOptions.value,
                                "events.duplicatedInterest.body.text"
                            )
                        ) {
                            bodyText =
                                normalizedOptions.value.events
                                    .duplicatedInterest.body.text;
                        }
                        responseDialog.value = {
                            show: true,
                            icon: {
                                show: true,
                                size: 112,
                                icon: "mdi-information-outline",
                            },
                            header: {
                                show: true,
                                text: headerText,
                            },
                            body: {
                                show: true,
                                text: bodyText,
                            },
                            closeButton: {
                                show: true,
                                color: "primary",
                            },
                        };
                    }
                })
                .then(function () {
                    loading.value = false;
                    sendingForm.value = false;
                });
        }

        function buildPayload() {
            let payload = clone(formFields.value);
            if (has(payload, "livingCircumstance.id")) {
                payload.livingCircumstance = payload.livingCircumstance.id;
            }
            if (has(payload, "workingCircumstance.id")) {
                payload.workingCircumstance = payload.workingCircumstance.id;
            }
            if (has(payload, "bestTimeToContactYou")) {
                payload.bestTimeToContactYou = [payload.bestTimeToContactYou];
            }
            if (has(payload, "newsletterConsent")) {
                if (payload.newsletterConsent === true) {
                    payload.newsletterConsent = 1;
                } else if (payload.newsletterConsent === false) {
                    payload.newsletterConsent = 0;
                }
            }
            if (has(payload, "newsSurveysConsent")) {
                if (payload.newsSurveysConsent === true) {
                    payload.newsSurveysConsent = 1;
                } else if (payload.newsSurveysConsent === false) {
                    payload.newsSurveysConsent = 0;
                }
            }
            if (has(payload, "partnersOffersConsent")) {
                if (payload.partnersOffersConsent === true) {
                    payload.partnersOffersConsent = 1;
                } else if (payload.partnersOffersConsent === false) {
                    payload.partnersOffersConsent = 0;
                }
            }

            // if (has(payload, "WhatsAppConsent")) {
            //     if (selected.includes("WhatsApp")) {
            //         payload.WhatsAppConsent = 1;
            //     } else {
            //         payload.WhatsAppConsent = 0;
            //     }
            // }

            // if (selected.value.length) {
            //     payload.selected = selected.value;
            // }

            if (selected.value.includes("WhatsApp")) {
                payload.whatsappConsent = 1;
            }

            if (selected.value.includes("SMS")) {
                payload.smsConsent = 1;
            }
            if (selected.value.includes("Phone")) {
                payload.phoneConsent = 1;
            }
            if (selected.value.includes("Email")) {
                payload.emailConsent = 1;
            }

            if (has(payload, "privacyPolicyAccepted")) {
                if (payload.privacyPolicyAccepted === true) {
                    payload.privacyPolicyAccepted = 1;
                } else if (payload.privacyPolicyAccepted === false) {
                    payload.privacyPolicyAccepted = 0;
                }
            }
            if (loggedInProfile.value) {
                delete payload.email;
                delete payload.password;
            }
            return payload;
        }

        function getError(fieldName) {
            return has(validationErrors.value.errors, fieldName);
        }

        function getErrorMessages(fieldName) {
            if (getError(fieldName)) {
                return validationErrors.value.errors[fieldName];
            }
            return [];
        }

        function scrollToElement(
            target,
            duration = 300,
            offset = 0,
            easing = "easeInOutCubic"
        ) {
            if (isNil(target)) {
                return;
            }
            let options = {
                duration: duration,
                offset: offset,
                easing: easing,
            };
            context.root.$vuetify.goTo(target, options);
        }

        function removeErrorMessage(fieldName) {
            if (has(validationErrors.value.errors, fieldName)) {
                delete validationErrors.value.errors[fieldName];
            }
        }

        function openLoginDialog() {
            loginDialog.value = true;
        }

        function closeLoginDialog() {
            loginDialog.value = false;
        }

        function setFormFieldsFromProfile(profile) {
            if (profile.title && normalizedOptions.value.fields.title.show) {
                formFields.value.title = profile.title;
            }
            if (
                profile.firstName &&
                normalizedOptions.value.fields.firstName.show
            ) {
                formFields.value.firstName = profile.firstName;
            }
            if (
                profile.lastName &&
                normalizedOptions.value.fields.lastName.show
            ) {
                formFields.value.lastName = profile.lastName;
            }
            if (
                profile.dateOfBirth &&
                normalizedOptions.value.fields.dateOfBirth.show
            ) {
                formFields.value.dateOfBirth = profile.dateOfBirth;
            }
            if (profile.phone && normalizedOptions.value.fields.phone.show) {
                formFields.value.phone = profile.phone;
            }
            if (profile.email) {
                formFields.value.email = profile.email;
            }
            if (
                profile.homeOwnershipStatus &&
                normalizedOptions.value.fields.homeOwnershipStatus.show
            ) {
                formFields.value.homeOwnershipStatus =
                    profile.homeOwnershipStatus;
            }
            if (
                profile.dependants &&
                normalizedOptions.value.fields.dependants.show
            ) {
                formFields.value.dependants = profile.dependants;
            }
            if (
                profile.homePostcode &&
                normalizedOptions.value.fields.homePostcode.show
            ) {
                formFields.value.homePostcode = profile.homePostcode;
            }
            if (
                profile.annualHouseholdIncome &&
                normalizedOptions.value.fields.annualHouseholdIncome.show
            ) {
                formFields.value.annualHouseholdIncome =
                    profile.annualHouseholdIncome;
            }
            if (
                profile.deposit &&
                normalizedOptions.value.fields.deposit.show
            ) {
                formFields.value.deposit = profile.deposit;
            }
            if (
                profile.occupation &&
                normalizedOptions.value.fields.occupation.show
            ) {
                formFields.value.occupation = profile.occupation;
            }
            if (
                profile.employerName &&
                normalizedOptions.value.fields.employerName.show
            ) {
                formFields.value.employerName = profile.employerName;
            }
            if (
                profile.workPostcode &&
                normalizedOptions.value.fields.workPostcode.show
            ) {
                formFields.value.workPostcode = profile.workPostcode;
            }

            if (has(profile, "armedForcesMember")) {
                if (profile.armedForcesMember === true) {
                    formFields.value.armedForcesMember = 1;
                } else if (profile.armedForcesMember === false) {
                    formFields.value.armedForcesMember = 0;
                }
            }
            if (has(profile, "eligibleCitizen")) {
                if (profile.eligibleCitizen === true) {
                    formFields.value.eligibleCitizen = 1;
                } else if (profile.eligibleCitizen === false) {
                    formFields.value.eligibleCitizen = 0;
                }
            }
            if (has(profile, "hasDisability")) {
                if (profile.hasDisability === true) {
                    formFields.value.hasDisability = 1;
                } else if (profile.hasDisability === false) {
                    formFields.value.hasDisability = 0;
                }
            }
            if (has(profile, "newsletterConsent")) {
                formFields.value.newsletterConsent = profile.newsletterConsent;
            }
            if (has(profile, "newsSurveysConsent")) {
                formFields.value.newsSurveysConsent =
                    profile.newsSurveysConsent;
            }
            if (has(profile, "partnersOffersConsent")) {
                formFields.value.partnersOffersConsent =
                    profile.partnersOffersConsent;
            }
            if (has(profile, "selected")) {
                formFields.value.selected = profile.selected;
            }

            // Living circumstance
            if (profile.livingCircumstance) {
                formFields.value.livingCircumstance =
                    profile.livingCircumstance;
                if (has(profile.livingCircumstance, "id")) {
                    let choice = find(
                        livingCircumstanceChoices.value,
                        function (o) {
                            return o.id == profile.livingCircumstance.id;
                        }
                    );
                    if (choice) {
                        formFields.value.livingCircumstance.owner =
                            choice.owner;
                    }
                }
            }

            // Working circumstance
            if (profile.workingCircumstance) {
                formFields.value.workingCircumstance =
                    profile.workingCircumstance;
                if (has(profile.workingCircumstance, "id")) {
                    let choice = find(
                        workingCircumstanceChoices.value,
                        function (o) {
                            return o.id == profile.workingCircumstance.id;
                        }
                    );
                    if (choice) {
                        formFields.value.workingCircumstance.working =
                            choice.working;
                    }
                }
            }

            // bestTimeToContactYou
            if (
                profile.bestTimeToContactYou &&
                normalizedOptions.value.fields.bestTimeToContactYou.show
            ) {
                formFields.value.bestTimeToContactYou =
                    profile.bestTimeToContactYou[0].id;
            }

            // buyingInterestPeriod
            if (
                profile.buyingInterestPeriod &&
                normalizedOptions.value.fields.buyingInterestPeriod.show
            ) {
                formFields.value.buyingInterestPeriod =
                    profile.buyingInterestPeriod.id;
            }

            formKey.value = formKey.value + 1;
        }

        function closeResponseDialog() {
            responseDialog.value.show = false;
        }

        function formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        }

        function handleLoginEmit(data) {
            if (data.loggedInProfile) {
                loggedInProfile.value = data.loggedInProfile;
            }
            if (data.accessToken) {
                token.value = data.accessToken;
            }
            setFormFieldsFromProfile(data.loggedInProfile);
        }

        function handleLoginDialogEmit(val) {
            loginDialog.value = val;
        }

        function init() {
            loading.value = true;
            Promise.all([
                HelperServices.getLivingCircumstances(),
                HelperServices.getWorkingCircumstances(),
                HelperServices.getBuyingInterestPeriods(),
                HelperServices.getBestTimeToContact(),
            ])
                .then((values) => {
                    if (has(values, "0.data.data")) {
                        livingCircumstanceChoices.value = values[0].data.data;
                    }
                    if (has(values, "1.data.data")) {
                        workingCircumstanceChoices.value = values[1].data.data;
                    }
                    if (has(values, "2.data.data")) {
                        buyingInterestPeriodChoices.value = values[2].data.data;
                    }
                    if (has(values, "3.data.data")) {
                        bestTimeToContactChoices.value = values[3].data.data;
                    }
                    fetchListing();
                })
                .catch((error) => {
                    console.error(error);
                })
                .then(() => {
                    loading.value = false;
                });

            ProfileService.getProfile()
                .then((response) => {
                    loggedInProfile.value = response;
                    setFormFieldsFromProfile(response);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (!loggedInProfile.value) {
                        window.addEventListener('storage', handleStorageChange);
                    }
                });
        }

        function handleStorageChange(storage) {
            if (storage.key !== 'access_token' || AuthenticationState.accessToken.value) {
                return;
            }
            ProfileState.registerApiCallDate();
            AuthenticationState.updateTokens(storage.newValue, localStorage.getItem('refresh_token'));
        }

        onMounted(() => {
            init();
        });

        return {
            // Variables
            loading,
            formValid,
            form,
            checkEligibility,
            listing,
            property,
            currencyFormatter,
            formFields,
            titleChoices,
            selected,
            extraMarketingInfoArray,
            armedForcesMemberChoices,
            eligibleCitizenChoices,
            hasDisabilityChoices,
            showDatePicker,
            picker,
            menu,
            livingCircumstanceChoices,
            workingCircumstanceChoices,
            buyingInterestPeriodChoices,
            bestTimeToContactChoices,
            working,
            registerInterestFields,
            rules,
            homeOwnershipStatusChoices,
            validationErrors,
            formResponse,
            listingImage,
            listingUrl,
            loginDialog,
            loggedIn,
            responseDialog,
            loggedInProfile,
            dateOfBirthFormatted,
            normalizedOptions,
            sendingForm,
            formKey,
            // Functions
            has,
            saveDobField,
            isFieldInCollection,
            validateForm,
            submitForm,
            showVerifyEmail,
            getAccessMagicLink,
            getError,
            getErrorMessages,
            removeErrorMessage,
            openLoginDialog,
            closeLoginDialog,
            closeResponseDialog,
            handleLoginEmit,
            handleLoginDialogEmit,
        };
    },
});
</script>

<style lang="scss">
#register {
    .v-text-field {
        &--outlined {
            fieldset {
                top: -12px !important;
            }
        }
    }
}
</style>
